import React from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

interface CategoryFieldProps {
  value: string;
  onChange: (value: string) => void;
  isSelected: boolean;
  onClick: () => void;
  options?: Array<{ text: string; value: string }>;
}

export const CategoryField: React.FC<CategoryFieldProps> = ({
  value,
  onChange,
  onClick,
  options = [],
}) => {

  return (
    <Box
      onClick={onClick}
    >
      <FormControl fullWidth>
        <InputLabel>Category</InputLabel>
        <Select
          labelId="category-select-label"
          id="category-select"
          label="Category"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          sx={{ width: '200px' }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};